module.exports = __webpack_public_path__ + "assets/img/442d257592779211b41a696ff345136e.svg";